module.exports = __webpack_public_path__ + "img/commissionDomonetization.c57876fd.svg";